import { useEffect, useState } from "react";

import "./NewCasePagePanel.css";
import "../../common/CasePanelHeader.css";
import { addClickRecord } from "../../../Utils/helper";
import AddIcon from "../../../assets/Add-icon-gold.svg";
import SOLIcon from "../../../assets/litigation/sol.svg";
import EditIcon from "../../../assets/edit.svg";

const NewCasePanels = ({
  panel_name,
  data,
  //   onSelectReport,
  hasBtn = false,
  hideFooterButton = false,
  imgSrc,
  buttonText,
  className,
  imgClassName,
  iconClassName,
  onClick = () => {},
  panelClassName = "",
  defaultLength = 6,
  colorGiven,
  leftHand = false,
  click,
  onRowClick,
  panelClassSpan = "",
  isLastPanel = false,
  clickId = 999,
}) => {
  const handleButtonClick = (e) => {
    if (onClick && typeof onClick === "function") {
      onClick(e);
      // addClickRecord(clickId, 1);
    }
  };

  const handleHeaderClick = (event) => {
    event.stopPropagation();
    handleButtonClick(event);
  };

  const buttonProps = {
    onClick: handleButtonClick,
  };

  const handleDataRowClick = (event, item) => {
    if (onRowClick) {
      event.stopPropagation();
      onRowClick(item);
      return;
    }

    if (item.value !== -1 && typeof click === "function") {
      click(item.value);
      if (panel_name === "CO-COUNSELlING FIRMS") {
        addClickRecord(clickId, 1);
      }
    }
  };

  const [_leftTiltAngle, setLeftTiltAngle] = useState(0);

  const adjustCaseDetailsWidths = () => {
    const leftColumns = document.querySelectorAll(".case-last-panel-tilt-name");

    let maxLeftWidth = 0;

    // Calculate maximum width for left and right columns
    leftColumns.forEach((column) => {
      const width = column.getBoundingClientRect().width;
      maxLeftWidth = Math.max(maxLeftWidth, width);
    });

    const width = Math.floor(maxLeftWidth);
    setLeftTiltAngle(width);
  };

  useEffect(() => {
    adjustCaseDetailsWidths();
    window.addEventListener("resize", adjustCaseDetailsWidths);
    return () => {
      window.removeEventListener("resize", adjustCaseDetailsWidths);
    };
  }, [isLastPanel, data]);
  const closedObj = data?.find((item) => item.id === "closed");
  const hasHeaderAdd = hasBtn && leftHand;
  const hasHeaderEdit = hasBtn && panel_name === "Open";
  const hasHeaderAction = hasHeaderAdd || hasHeaderEdit;
  const isCoCounselPanel = panel_name === "CO-COUNSELlING FIRMS";
  const PanelHeader = hasHeaderAction ? "button" : "div";
  const PanelTitle = hasHeaderAction ? "span" : "p";
  return (
    <>
      <div
        className={`background-div d-flex flex-column ${panelClassName} ${hasHeaderEdit ? "case-panel-edit-panel" : ""} ${isCoCounselPanel ? "co-counsel-panel" : ""}`}
      >
        <div
          className={isCoCounselPanel ? "co-counsel-panel-main" : ""}
          onClick={
            panel_name === "CO-COUNSELlING FIRMS"
              ? undefined
              : panel_name === "Statute of Limitations"
                ? undefined
                : handleButtonClick
          }
        >
          <PanelHeader
            className={`menu-bar-style ${isLastPanel ? "case-last-panel-tilt-name" : ""} ${hasHeaderAction ? "case-panel-action-header" : ""}`}
            type={hasHeaderAction ? "button" : undefined}
            onClick={hasHeaderAction ? handleHeaderClick : undefined}
            aria-label={hasHeaderAction ? buttonText : undefined}
            style={
              {
                // clipPath: isLastPanel
                //   ? `polygon(0% 0%, ${leftTiltAngle - 4}px 0%, 100% 100%, 0% 100%)`
                //   : "",
              }
            }
          >
            {panel_name === "Open" ? (
              <PanelTitle
                className="columnsTitle text-center d-flex text-primary font-weight-semibold text-uppercase"
                style={{
                  gap: "5px",
                }}
              >
                <span className={`${closedObj?.value ? "color-grey-2" : "color-green"}`}>
                  {panel_name}
                </span>{" "}
                Case
              </PanelTitle>
            ) : (
              <PanelTitle className="columnsTitle text-center d-flex text-primary font-weight-semibold text-uppercase">
                {panel_name}
              </PanelTitle>
            )}
            {hasHeaderAdd && (
              <span className="case-panel-header-icon case-panel-add-icon" aria-hidden="true" />
            )}
            {hasHeaderEdit && (
              <span className="case-panel-header-icon" aria-hidden="true">
                <img src={EditIcon} width="15" height="15" alt="" />
              </span>
            )}
          </PanelHeader>
          {panel_name !== "Statute of Limitations" && (
            <div
              className={`invisible-scrollbar ${isCoCounselPanel ? "co-counsel-panel-scroll" : ""}`}
              tabIndex={isCoCounselPanel ? 0 : undefined}
              role={isCoCounselPanel ? "region" : undefined}
              aria-label={isCoCounselPanel ? "Co-counsel firms" : undefined}
              style={
                isCoCounselPanel
                  ? undefined
                  : { maxHeight: "126px", overflow: "scroll", scrollbarWidth: "none" }
              }
            >
              {data.map((item, index) => (
                <div
                  className={`info-color-panels-odd-even d-flex align-items-center justify-content-between mb-0 colFont flex-wrap p-r-5 ${panel_name === "CO-COUNSELlING FIRMS" ? "ps-0" : "p-l-5"} ${onRowClick ? "case-panel-clickable-row cursor-pointer" : ""}`}
                  key={index}
                  role={onRowClick ? "button" : undefined}
                  tabIndex={onRowClick ? 0 : undefined}
                  onClick={
                    onRowClick || click ? (event) => handleDataRowClick(event, item) : undefined
                  }
                  onKeyDown={(event) => {
                    if (onRowClick && (event.key === "Enter" || event.key === " ")) {
                      event.preventDefault();
                      handleDataRowClick(event, item);
                    }
                  }}
                >
                  <div
                    className={`col ${panel_name === "CO-COUNSELlING FIRMS" ? "co-counsel-panel-row-content" : "height-21"} text-start p-0`}
                  >
                    <span
                      //   className="d-inline-block"
                      className={`${panelClassSpan} d-inline-block`}
                      style={{
                        color: colorGiven ? colorGiven : "black",
                        fontWeight: "600",
                      }}
                    >
                      {item.label}
                    </span>
                  </div>
                  {panel_name !== "CO-COUNSELlING FIRMS" && (
                    <div className="col-auto p-0 text-start font-weight-semibold">
                      <p>{item.value}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}

          {panel_name === "Statute of Limitations" && (
            <div
              className="invisible-scrollbar"
              style={{
                maxHeight: "126px",
                overflow: "scroll",
                scrollbarWidth: "none",
              }}
            >
              {data.map((item, index) => (
                <div
                  className="info-color-panels-odd-even d-flex align-items-center justify-content-between mb-0 colFont flex-wrap p-r-5 p-l-5"
                  key={index}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (item?.baseObj?.id !== -1 && typeof click === "function") {
                      click(item.baseObj);
                    }
                  }}
                >
                  <div className="col height-21 text-start p-0">
                    <div
                      className={`${panelClassSpan} text-start align-items-center justify-content-start`}
                      style={{
                        color: colorGiven ? colorGiven : "black",
                        fontWeight: "600",
                        minWidth: "150px",
                        maxWidth: "70%",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        className="d-flex align-items-center"
                        style={{
                          gap: "5px",
                          minWidth: 0, // 🔥 VERY IMPORTANT (for flex ellipsis)
                        }}
                      >
                        <img src={SOLIcon} className="ic ic-15" />

                        <span
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            display: "block",
                            minWidth: 0,
                          }}
                        >
                          {item.eventName}
                        </span>
                      </div>
                    </div>
                  </div>
                  {panel_name !== "CO-COUNSELlING FIRMS" && (
                    <div className="col-auto p-0 text-start font-weight-semibold">
                      <p>{item.value}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
          {!isCoCounselPanel &&
            data.length < defaultLength &&
            Array.from({ length: 6 - data.length }).map((_, index) => (
              <div
                className="info-color-panels-odd-even d-flex align-items-center justify-content-between mb-0 colFont flex-wrap"
                style={{ height: "21px" }}
                key={`${index}`}
              />
            ))}
        </div>
        {hasBtn && !hideFooterButton && (
          <div className={`mt-0 ${isCoCounselPanel ? "co-counsel-panel-footer" : ""}`}>
            <button
              {...buttonProps}
              className={`btn w-100 info-panel-button-hover-state font-weight-semibold text-lg height-25 rounded-0 d-flex align-items-center justify-content-center ${className}`}
              //   onClick={onClick}
              style={{
                backgroundColor: "var(--primary-10)",
                color: "var(--primary)",
                border: "1px solid var(--primary)",
              }}
            >
              {iconClassName && <i className={`${iconClassName} me-1`} />}
              {imgSrc && <img className={imgClassName} src={imgSrc} alt="icon" />}
              {leftHand && (
                <span
                  className="fw-bold ic-15 d-flex align-items-center justify-content-center p-r-5"
                  style={{
                    color: "#c49e09",
                    width: "15px",
                    height: "15px",
                  }}
                >
                  <img src={AddIcon} alt="Add Icon" className="ic-15" />
                </span>
              )}
              {buttonText}
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default NewCasePanels;
